(function () {
  'use strict';

  /* ─── PostHog ─────────────────────────────────────────────────────────────
   *
   * PRE-LAUNCH PREFIX ON PURPOSE. `lst001_`, not `lst001live_`. Per
   * docs/posthog-setup.md the bare prefix is where test traffic goes; the
   * `…live_` one is created when the page actually ships, so launch numbers are
   * never polluted by the building of it. Renaming later is instant and keeps the
   * old data readable — PostHog has no event deletion.
   *
   * The seven standard events do not all apply here. This is an advertorial: no
   * gallery, no FAQ accordion, no add-to-cart of its own — every CTA is a link to
   * the product page. So `cta_click` stands in for add_to_cart, and `item_viewed`
   * is added, because on a page whose whole job is to be read, WHERE people stop
   * is the question worth answering. */
  var PH_PREFIX = 'lst001_';
  var PAGESET = 'LST001';

  function ph(event, props) {
    try {
      if (!window.posthog || !window.posthog.capture) return;
      var p = props || {};
      p.page_template = PAGESET;
      window.posthog.capture(PH_PREFIX + event, p);
    } catch (e) {}
  }

  var progressBar = null;
  var topBar = null;
  var lastScrollY = 0;
  var ticking = false;

  function init() {
    progressBar = document.querySelector('.lst__progress-fill');
    topBar = document.querySelector('.lst__top-bar');

    /* Header and footer are suppressed in layout/theme.liquid, not here. Doing it
       in JS meant the chrome rendered and was then hidden a frame later — a
       visible flash on every load, and it left the markup in the document for
       anything else to measure. The template-suffix conditions there simply never
       emit it. */

    /* No sticky CTA bar. The li05 reference this page is modelled on has none —
       its only fixed element is the progress wrapper; its `sticky-cta` lives in a
       hidden sidebar and its `sticky_bar` is an inline block. The bar here was
       inherited from reformly-weight-loss, not chosen. */

    // Scroll listener for progress bar + header hide
    if (progressBar || topBar) {
      window.addEventListener('scroll', onScroll, { passive: true });
      /* Resize too, as the li05 reference does. The fill is a fraction of
         (scrollHeight - innerHeight); an orientation change or a resized window
         changes that denominator, and without this the bar keeps showing the old
         percentage until the next scroll event. */
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    initTracking();
    syncTopOffset();
  }

  /* The top bar is position:fixed, so it reserves no space — the content has to
     clear it itself. A literal in the CSS cannot: the banner label is an editable
     setting and wraps on narrow screens, which changes the bar's height.

     Measured at the bar's FULL height, before the scroll collapse kicks in, since
     that is exactly the state in which the h1 is on screen. */
  function syncTopOffset() {
    var content = document.querySelector('.lst__content');
    if (!topBar || !content) return;

    /* TWO fixed bars stack at the top of this page: the theme's announcement bar
       and this page's own FITNESS-INSIDER bar. Neither height is knowable from
       CSS — the announcement copy is a theme setting and this page's label is a
       section setting, and both wrap on narrow screens. So the announcement bar
       is measured, this bar is pushed below it, and the content clears both. */
    function announceEl() {
      /* Prefix match: section-group ids render as
         shopify-section-sections--<id>__announcement_bar_m8zXGk, so an exact id
         finds nothing. */
      return document.querySelector('[id^="shopify-section"][id*="announcement"], .announcement-bar-section');
    }

    function apply() {
      var a = announceEl();
      var aH = a ? a.offsetHeight : 0;
      topBar.style.top = aH + 'px';

      /* Measured at FULL height only: the banner collapses past 50px of scroll,
         and measuring then would set an offset ~53px short — but the hero is only
         on screen at the top, where the bar is full. */
      if (topBar.classList.contains('lst__top-bar--collapsed')) return;
      var h = topBar.offsetHeight;
      /* aH + h clears the two fixed bars exactly; the gap on top is the only
         part that is a design choice, so it comes from --lst-top-gap rather than
         a constant here — mobile wants less of it than desktop. */
      var gap = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--lst-top-gap'), 10
      );
      if (isNaN(gap)) gap = 16;
      if (h > 0) content.style.paddingTop = (aH + h + gap) + 'px';
    }

    apply();
    window.addEventListener('resize', apply, { passive: true });
    window.addEventListener('load', apply);   // webfont swap changes both heights

    /* The announcement bar belongs to the theme, not this section, so it can
       render or reflow after this runs — an app injecting into it, a webfont
       landing, its copy wrapping. Observing it means the offset re-applies
       instead of being measured once against a bar that was not there yet. */
    var a = announceEl();
    if (a && window.ResizeObserver) new ResizeObserver(apply).observe(a);
  }

  /* Every event this page emits. Kept in one function so the tracking surface is
     readable in one place rather than scattered through the scroll handlers. */
  function initTracking() {
    try {
      if (window.posthog && window.posthog.register) {
        window.posthog.register({ reformly_pageset: PAGESET });
      }
    } catch (e) {}

    ph('reformly_plus_page_view', {
      url: window.location.href,
      referrer: document.referrer
    });

    /* CTA clicks. Delegated on document with capture:true for the same reason
       posthog-setup.md documents for the sticky ATC — a handler that runs late
       can miss a click on an element the page is already navigating away from.
       Capture runs root->target, before anything can swallow it. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;

      var where = null;
      if (a.classList.contains('lst__cta-btn')) where = 'offer';
      else if (a.classList.contains('lst__inline-link')) where = 'inline';
      if (!where) return;

      /* Which of the two offer blocks: the mid-article one converts differently
         from the one at the end, and that is the main thing this layout is
         testing. */
      var index = null;
      if (where === 'offer') {
        var all = Array.prototype.slice.call(document.querySelectorAll('.lst__offer-btn'));
        index = all.indexOf(a) + 1;
      }

      ph('reformly_plus_cta_click', {
        source: where,
        offer_index: index,
        href: a.getAttribute('href'),
        /* How far down they were when they converted — on an advertorial the
           depth at which a CTA works is the interesting number. */
        depth: scrollDepthPct()
      });
    }, true);

    trackScrollDepth();
    trackItemsRead();
  }

  function scrollDepthPct() {
    var h = document.documentElement;
    var max = (h.scrollHeight - h.clientHeight);
    if (max <= 0) return 0;
    return Math.min(100, Math.round((h.scrollTop || window.pageYOffset) / max * 100));
  }

  /* 25/50/75/100, once each per pageview. */
  function trackScrollDepth() {
    var fired = {};
    function check() {
      var pct = scrollDepthPct();
      [25, 50, 75, 100].forEach(function (mark) {
        if (pct >= mark && !fired[mark]) {
          fired[mark] = true;
          ph('reformly_plus_scroll_depth', { depth: mark });
        }
      });
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* One event the first time each numbered item is more than half on screen.
     This is the drop-off curve for the article itself — which heading loses
     people, and whether anyone reaches the second offer block. */
  function trackItemsRead() {
    if (!('IntersectionObserver' in window)) return;
    var items = document.querySelectorAll('.lst__item');
    if (!items.length) return;

    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = Array.prototype.indexOf.call(items, entry.target) + 1;
        if (seen[idx]) return;
        seen[idx] = true;
        var titleEl = entry.target.querySelector('.lst__item-title');
        ph('reformly_plus_item_viewed', {
          item_index: idx,
          item_title: titleEl ? titleEl.textContent.trim() : null
        });
        io.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }




  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function update() {
    ticking = false;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return;

    var scrollPercent = (scrollTop / docHeight) * 100;

    // Update reading progress bar
    if (progressBar) {
      progressBar.style.width = Math.min(scrollPercent, 100) + '%';
    }

    // Collapse banner on scroll, only expand at very top
    if (topBar) {
      if (scrollTop > 50) {
        topBar.classList.add('lst__top-bar--collapsed');
      } else {
        topBar.classList.remove('lst__top-bar--collapsed');
      }
    }

    lastScrollY = scrollTop;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
